module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Scheduled Social Post Calendar")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('full-calendar', {
    ref: "fullCalendar",
    attrs: {
      "defaultView": "dayGridMonth",
      "plugins": _vm.calendarPlugins,
      "header": {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      "events": _vm.calendarEvents,
      "droppable": true,
      "editable": true,
      "nowIndicator": true,
      "eventRender": _vm.handleEventRender,
      "timeZone": 'local'
    },
    on: {
      "eventClick": _vm.handleEventClick,
      "dateClick": _vm.handleDateClick,
      "eventDrop": _vm.handleEventDrop
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c83c1db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/SocialPostCalendar.vue
// module id = 3271
// module chunks = 3